import React, { Component } from 'react';
import { Card, Button, CardHeader, CardFooter, CardBody, 
    CardText, Dropdown, DropdownToggle, DropdownMenu, 
    DropdownItem, TabContent, TabPane, Nav, NavItem, NavLink,  
    Row, Col, Table, Badge, UncontrolledTooltip } from 'reactstrap';
import {COLOR, FMJD_PHOTO_URL, 
        FMJD_FLAGS_URL, FMJD_GET_GAMES_SRC_PATH,
        FMJD_CORE_POST_GAMES_SCRIPT, ModalResult, THIS_URL} from './Constans'
import BoardView from './BoardView';
import GameEngine from './GameEngine';
import BoardViewPlayer from './BoardViewPlayer';
import "./GameComponent.css";
import "bootstrap-css-only/css/bootstrap.css";
import "glyphicons-only-bootstrap/css/bootstrap.css";
import classnames from 'classnames';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import QuestionModal from './QuestionModal';
import axios from 'axios';
import MessageModal from "./MessageModal"
import CommentView from "./CommentView"
import {DraughtsTypes8x8} from "./utils/symbols"

export default class GameComponent extends Component {
    constructor(props) {
        super(props);
        this.state = this.generateStateByJSON(props.gameData);
        this.md5 = props.gameData.md5;
        this.doAutoPlay = this.doAutoPlay.bind(this);
        this.toogleToolsWindow = this.toogleToolsWindow.bind(this);
        this.toggleTab = this.toggleTab.bind(this);
        this.gotoMove = this.gotoMove.bind(this);
        this.onSquareClick = this.onSquareClick.bind(this);
        this.postDataToServer = this.postDataToServer.bind(this);
        this.onMessageModalResult = this.onMessageModalResult.bind(this);
        this.toogleMovesEdit = this.toogleMovesEdit.bind(this);
        this.onCommentsLength = this.onCommentsLength.bind(this);
        this.updateGameFromServer = this.updateGameFromServer.bind(this);
        this.deleteGameFromThatMove = this.deleteGameFromThatMove.bind(this);
        this.questionModalDeleteRestMoves = this.questionModalDeleteRestMoves.bind(this);

        this.duringUpdate = false;
        const emptyResult = props.gameData.result === '' || props.gameData.result === ' : ';
        this.gameOnline = (props.gameData.gameOnline === '1' || this.props.settingsData.liveCurrentRound === props.gameData.round) && emptyResult;
        this.state.toolsWindowEnable = false;
        
        this.state.baseHeight = 100;
        this.state.tabContentHeight = 75;
        this.state.activeTab = '1';
        this.state.autoPlayInterval = 0;
        this.state.destinationSquare = 0;
        this.state.needsUpdatePDN = false;
        this.state.movesEdit = false;
       
        if (this.props.settingsData && this.props.settingsData.isGameEditUserLogin &&
            this.game.getMovesSize() === 0) {
                this.state.movesEdit = true;
            }
        this.state.commentsLength = 0;
        this.state.showQuestionModalDeleteFrom = false;
        

        this.state.selectedSquares = this.game.getEmptySelectedSquare();

        this.state.messageModal = {
            title: "",
            message: "",
            visible: false
        }

        this.counter = 3;
        this.lastSave = props.gameData.lastSave * 1;
        if (this.lastSave === 0) {
            this.lastSave = 1;
        } else {
            this.lastSave += 1;
        }
        this.movesTableNewScrollTop = 0;
        this.forceMoveGrid = false;

 
    }

    
    generateStateByJSON(gameData, whiteOnTop) {
        gameData.pdn = gameData.pdn.replaceAll('    ', ' ');
        gameData.pdn = gameData.pdn.replaceAll('   ', ' ');
        gameData.pdn = gameData.pdn.replaceAll('  ', ' ');
        gameData.pdn = gameData.pdn.replaceAll('  ', ' ');
        gameData.pdn = gameData.pdn.replaceAll('  ', ' ');
        gameData.pdn = gameData.pdn.replaceAll('. ', '.');
        gameData.pdn = gameData.pdn.replaceAll('\\n', '');
        gameData.pdn = gameData.pdn.replaceAll('\\', '');
        gameData.pdn = gameData.pdn.replaceAll('\"', '"');
        let draughtsType = DraughtsTypes8x8.convertFromDAP(gameData.draughtsType);
        let game = this.game = new GameEngine(gameData, whiteOnTop, draughtsType);
        try {
            game.parsePDN(gameData.pdn);
        } catch (e) {
            console.error("Unable to parse game:", gameData.pdn);
        }
        return {
            draughtsType: draughtsType,
            whitePlayerName:  game.getWhitePlayerName(),
            blackPlayerName:  game.getBlackPlayerName(),
            whitePlayerTitle: (game.getWhitePlayerTitle() +' '+ game.getWhitePlayerRank() +' '+ game.getWhitePlayerFed()),
            blackPlayerTitle: (game.getBlackPlayerTitle() +' '+ game.getBlackPlayerRank() +' '+ game.getBlackPlayerFed()),
            whitePlayerFlag: FMJD_FLAGS_URL + game.getWhitePlayerFed() + ".png",
            blackPlayerFlag: FMJD_FLAGS_URL + game.getBlackPlayerFed() + ".png",
            whitePlayerPhoto: FMJD_PHOTO_URL + game.getWhitePlayerFmjdId() + ".PNG",
            blackPlayerPhoto: FMJD_PHOTO_URL + game.getBlackPlayerFmjdId() + ".PNG",
            whitePlayerResult: game.getResultWhite(),
            blackPlayerResult: game.getResultBlack(),
            boardType: game.getBoardType(),
            currentPositionData: game.getCurrentPositionData(),
            movesTekstArray: game.getPairMoves(),
            pdn: game.getPDN(),
            whiteOnTop: whiteOnTop,
            dapGameKey: gameData.dapGameKey,
            dapTournamentKey: gameData.dapTournamentKey
            
        }
    }

    toggleTab(tab) {
        if (this.state.activeTab !== tab) {
            
            this.setState({
                activeTab: tab
            });
        }
    }

    linkCheck(url)
    {
        var http = new XMLHttpRequest();
        http.open('HEAD', url, false);
        try {
            http.send();
        } catch (e) {}
        return http.status!=404;
    }
   
    updateGameFromServer() {
        if (this.state.movesEdit) {
            return;
        }
        var config = {
            crossDomain: true,
        };
        const that = this;
        this.duringUpdate = true;
        console.log('lastSave1', this.lastSave);
        const url = FMJD_GET_GAMES_SRC_PATH + "?dapTournamentKey=" + this.props.gameData.dapTournamentKey 
            + "&dapGameKey=" + this.props.gameData.dapGameKey
            + "&lastSave=" + this.lastSave;
        axios.get(url, config)
        .then(res => {
            const gameData = res.data;
            if (Array.isArray(gameData) && gameData.length > 0) {
                if (this.md5 !== gameData[0].md5) {
                    const currentMove = that.game.getCurrentMove();
                    const wasOnline = that.gameOnline;
                    let newState = that.generateStateByJSON(gameData[0], that.state.whiteOnTop);
                    that.game.gotoMove(currentMove);
                    newState.currentPositionData = that.game.getCurrentPositionData();
                    const emptyResult = gameData[0].result === '' || gameData[0].result === ' : ';
                    that.gameOnline = (gameData[0].gameOnline === '1' || this.props.settingsData.liveCurrentRound === gameData[0].round) && emptyResult;
                    this.lastSave = gameData[0].lastSave * 1;
                    this.lastSave += 1;
                    console.log('lastSave2', this.lastSave);
                    console.log(newState);
                    that.setState(newState);
                    if (that.gameOnline !== wasOnline) {
                        if (that.gameOnline) {
                            that.toggleAutoPlay(2000);
                        } else {
                            that.toggleAutoPlay(0);
                        }
                    }
                    this.md5 = gameData[0].md5;
                }
            }
            this.duringUpdate = false;
        })
        .catch(err => {
            //console.error(err);
            this.duringUpdate = false;
        })
    }

    doAutoPlay() {
        if (this.counter-- == 0 && this.gameOnline) {
            if (!this.duringUpdate) {
                this.updateGameFromServer();
            }
            this.counter = 30;
        }
        this.nextMove();
    }


   
    flipBoard() {
        let white = !this.state.whiteOnTop;
        this.setState({
            whiteOnTop: white
        })
    }

    deleteGameFromThatMove() {
        this.setState({
            showQuestionModalDeleteFrom: true
        })
    }

    questionModalDeleteRestMoves(result) {
        if (result === ModalResult.RESULT_YES) {
            this.game.removeRestMoves();
            this.setState({
                needsUpdatePDN: true,
                movesTekstArray: this.game.getPairMoves(),
                currentMove: this.game.getCurrentMove(),
                pdn: this.game.getPDN(),
            })
        }
        this.setState({
            showQuestionModalDeleteFrom: false
        })
    }

    calculateMovesGridPosition(lastMove) {
        if (!this.state.toolsWindowEnable) {
            return;
        }
        const fullLastMove = parseInt((lastMove + 1) / 2.0, 10);
        const fullCurrentMove = parseInt((this.game.getCurrentMove() + 1) / 2.0, 10);
        this.movesTableNewScrollTop = this.movesTableLastScrollTop + ((fullCurrentMove - fullLastMove) * this.movesTableRowHeight);
        this.forceMoveGrid = true;
        if (this.movesTableNewScrollTop < 0) {
            this.movesTableNewScrollTop = 0;
        }
    }

    firstMove() {
        this.game.firstMove();
        this.movesTableNewScrollTop = 0;
        this.forceMoveGrid = true;
        this.setState({
            currentPositionData: this.game.getCurrentPositionData(),
            currentMove: this.game.getCurrentMove(),
            selectedSquares: this.game.getEmptySelectedSquare()
        })
    }
    lastMove() {
        const lastMove = this.game.getCurrentMove();
        this.game.lastMove();
        this.calculateMovesGridPosition(lastMove);
        this.setState({
            currentPositionData: this.game.getCurrentPositionData(),
            currentMove: this.game.getCurrentMove(),
            selectedSquares: this.game.getEmptySelectedSquare()
        })
    }

    prevMove() {
        const lastMove = this.game.getCurrentMove();
        this.game.prevMove();
        this.calculateMovesGridPosition(lastMove);
        this.setState({
            currentPositionData: this.game.getCurrentPositionData(),
            currentMove: this.game.getCurrentMove(),
            selectedSquares: this.game.getEmptySelectedSquare()
        })
    }

    nextMove() {
        if (!this.game.hasNextMove()) {
            return;
        }
        const lastMove = this.game.getCurrentMove();
        this.game.nextMove();
        this.calculateMovesGridPosition(lastMove);
        this.setState({
            currentPositionData: this.game.getCurrentPositionData(),
            currentMove: this.game.getCurrentMove(),
            selectedSquares: this.game.getEmptySelectedSquare()
        })
    }
    
    gotoMove(move) {
        this.game.gotoMove(move);
        this.setState({
            currentPositionData: this.game.getCurrentPositionData(),
            currentMove: this.game.getCurrentMove(),
            selectedSquares: this.game.getEmptySelectedSquare()
        })
    }

  

    toogleToolsWindow() {
        const toogle = !this.state.toolsWindowEnable;
        if (toogle) {
            this.forceNewGridPosition = true;
        }
        this.setState({
            toolsWindowEnable: toogle
        })
    }

    componentWillUnmount() {
        clearInterval(this.timerAutoPlay);
        clearInterval(this.timerAutoUpdate);
        this.mounted = false;
        
    }

    componentDidUpdate(prevProps) {
        if (!this.state.toolsWindowEnable) {
            return;
        }
        if (this.refs.scrollBar) {
            if (this.refs.moveTR) {
                if (this.forceNewGridPosition) {
                    const fullLastMove = parseInt((this.game.getCurrentMove() + 1) / 2.0, 10);
                    this.refs.scrollBar.scrollTop = fullLastMove * this.refs.moveTR.clientHeight;
                    this.forceNewGridPosition = false;
                } else if (this.forceMoveGrid) {
                    this.refs.scrollBar.scrollTop = this.movesTableNewScrollTop;
                    this.forceMoveGrid = false;
                }
                this.movesTableRowHeight = this.refs.moveTR.clientHeight;
                this.movesTableLastScrollTop = this.refs.scrollBar.scrollTop;
            }
        }
    }

    componentDidMount(){
        this.mounted = true;
        let { clientHeight }  = this.refs.baseTD;

        if (this.props.movesWindowOpened) {
            this.toogleToolsWindow();
        }

        this.setState({
            baseHeight: clientHeight - 10,
            tabContentHeight: parseInt((clientHeight/4.0) * 3.0, 10)
        })

        if (this.gameOnline) {
            clearInterval(this.updateGameFromServer);
            this.game.lastMove();
            clearInterval(this.timerAutoPlay);
            this.timerAutoPlay = setInterval(this.doAutoPlay, 2000);
            this.setState({
                currentPositionData: this.game.getCurrentPositionData(),
                autoPlayInterval: 2000
            })
        } else {
            clearInterval(this.updateGameFromServer);
            this.timerAutoUpdate = setInterval(this.updateGameFromServer, 60000);
        }
        
    }

    getMovesListButton(toolWindow) {
        let result = null;
        
        let toolMenuIcon = <span><span className="glyphicon glyphicon-list-alt"></span><span className="glyphicon glyphicon-arrow-right"></span></span>
        
        if (toolWindow) {
            toolMenuIcon = <span><span className="glyphicon glyphicon-list-alt"></span><span className="glyphicon glyphicon-arrow-left"></span></span>
        }
        if (this.props.settingsData && this.props.settingsData.movesListEnable === '1') {
            result = <Button size="sm" onClick={() => this.toogleToolsWindow()}>{toolMenuIcon}</Button>
        }
        return result;
    }

    toggleAutoPlay(interval) {
        
        if (this.timerAutoPlay) {
            clearInterval(this.timerAutoPlay);
        }
        if (interval === this.state.autoPlayInterval) {
            interval = 0;
        }
        if (interval > 0) {
            this.timerAutoPlay = setInterval(this.doAutoPlay, interval);
        } 
        this.setState({
            autoPlayInterval: interval
        })
    }

    _addNewMoveBySelected(selectedSquare, squareId) {

        if (selectedSquare.isDestinationSquare) {
            this.game.addMove(squareId, selectedSquare.selectedSquare);
        } else {
            this.game.addMove(selectedSquare.selectedSquare, squareId);
        }

        this.nextMove();
        this.setState({
            needsUpdatePDN: true,
            movesTekstArray: this.game.getPairMoves(),
            currentMove: this.game.getCurrentMove(),
            pdn: this.game.getPDN(),
        })
    }

    onSquareClick(squareId) {
        if (!this.state.movesEdit) return;
        
        if (this.game.getMovesSize() > this.game.getCurrentMove()) {
            this.game.removeRestMoves();
            this.setState({
                needsUpdatePDN: true,
                movesTekstArray: this.game.getPairMoves(),
                currentMove: this.game.getCurrentMove(),
                pdn: this.game.getPDN(),
            })
        }

        if (this.state.selectedSquares.validMoves.length > 0) {
            if (squareId !== this.state.selectedSquares.selectedSquare) {
                this._addNewMoveBySelected(this.state.selectedSquares, squareId);
                return;
            }
        } 

        let selSquares = {}
        
        if (this.game.isEmpty(squareId)) {
            selSquares = this.game.getValidMovesGetSourceFields(squareId);
        } else {
            selSquares = this.game.getValidMoves(squareId);
        }

        if (selSquares.validMoves.length === 1) {
            this._addNewMoveBySelected(selSquares, selSquares.validMoves[0]);
            return;
        }

        this.setState({
            selectedSquares: selSquares,
        })
    }
    
    
    getPDNButton() {
        
        let result = null;
        if (this.props.settingsData.pdnButtonEnable === '1') {
            let pdnSourceText = this.game.getPDN();
            result = 
            <div style={{textAlign:"right"}}>
                <CopyToClipboard text={pdnSourceText}
                    onCopy={() => this.setState({copied: true})}>
                    <h4 style={{ cursor: 'pointer' }}>
                    <Badge id='copyPDNTooltip' color="secondary"><span className="glyphicon glyphicon-copy"></span></Badge>
                    </h4>
                </CopyToClipboard>
                <UncontrolledTooltip placement="top" target="copyPDNTooltip">
                Copy PDN to clipboard
                </UncontrolledTooltip>
            </div>
        }
        return result;
    }

    postDataToServer() {
        const querystring = require('querystring');
        const urlGames = FMJD_CORE_POST_GAMES_SCRIPT;
        let that = this;
        const pwdData = JSON.parse(localStorage.getItem('gep_dap') || '{}');
        let pwd = '';
        if (this.props.settingsData !== undefined) {
            pwd = pwdData[this.props.settingsData.dapTournamentKey];
        }
        axios({
            method: 'post',
            url: urlGames,
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            data: querystring.stringify({
                dapTournamentKey: btoa(this.game.gameJSON.dapTournamentKey),
                dapGameKey: btoa(this.game.gameJSON.dapGameKey),
                editUserId: btoa(this.props.settingsData.user_id),
                editUserName: btoa(this.props.settingsData.user_name),
                pdn: btoa(this.game.getPDN()),
                sessionKey: btoa(this.props.settingsData.sessionKey),
                localPwd: btoa(pwd),
            })
        })
        .then(function (response) {
            if (!that.mounted) {
                return;
            }
            if (response.data.status === "ok" || response.data.status === "latest") {
                that.setState({
                    needsUpdatePDN: false
                })
            } else if (response.data.status === "session") {
                that.setState({
                    messageModal: {
                        title: "Error",
                        message: "Session expired. Please log in to the site http://results.fmjd.org/ then reload this page (F5).",
                        visible: true,
                    }
                }) 
            } else {
                that.setState({
                    messageModal: {
                        title: "Error",
                        message: "Unable to save data. Error:2221",
                        visible: true,
                    }
                })
            }
        })
        .catch(function (error) {
            if (!that.mounted) {
                return;
            }
            that.setState({
                messageModal: {
                    title: "Error",
                    message: error.message,
                    visible: true,
                }
            })
         });
    }
    onCommentsLength(length) {
        this.setState({
            commentsLength: length
        })
    }
    getCommentsTab(sizeComp) {
        let result = {};
        if (this.props.settingsData && this.props.settingsData.commentsEnable === '1') {
            result.header = 
                <NavItem>
                        <NavLink onClick={() => { this.toggleTab('2'); }} 
                        className={classnames({ active: this.state.activeTab === '2' })} 
                        style={{ cursor: 'pointer' }}>
                        Comments&nbsp;{this.state.commentsLength > 0 &&
                        <Badge color="secondary">{this.state.commentsLength}</Badge>}
                        </NavLink>
                </NavItem>
            result.body =
                <TabPane tabId="2">
                <CommentView 
                    width={sizeComp}
                    boardType={this.state.boardType}
                    currentFEN={this.game.getCurrentFen()}
                    dapTournamentKey={this.state.dapTournamentKey} 
                    dapGameKey={this.state.dapGameKey}
                    settings={this.props.settingsData} 
                    tabContentHeight={this.state.tabContentHeight}
                    onCommentsLength={this.onCommentsLength}>
                </CommentView>
                </TabPane>
        }
        return result;
    }

    getMovesListTab(sizeComp) {
        let result = {}
        if (this.props.settingsData && this.props.settingsData.movesListEnable === '1') {
            const moves = this.state.movesTekstArray;
            result.header =
                <NavItem>
                    <NavLink onClick={() => { this.toggleTab('1'); }}
                        className={classnames({ active: this.state.activeTab === '1' })} style={{ cursor: 'pointer' }}>
                    Moves&nbsp;{moves.length > 0 &&
                        <Badge color="secondary">{moves.length}</Badge>}
                    </NavLink>
                </NavItem>


            const current = this.state.currentMove;
            let movesArrayHtml = [];
            let m = 0;
            for (let i = 0; i<moves.length; i++) {
                const move = moves[i];
                m++;
                const moveWhite = (current === m) ? <Badge style={{ cursor: 'pointer' }} color="success">{move.white}</Badge> 
                                    : <Badge style={{ cursor: 'pointer' }} color="light">{move.white}</Badge>;
                const moveWhiteNo = m;
                m++;
                const moveBlack = (current === m) ? <Badge style={{ cursor: 'pointer' }} color="success">{move.black}</Badge> 
                             
                : <Badge style={{ cursor: 'pointer' }} color="light">{move.black}</Badge>;
                
                const moveBlackNo = m;
                movesArrayHtml.push(<tr ref="moveTR" key={'tr'+i}><th scope="row">{move.number}</th>
                                    <td onClick = {()=>this.gotoMove(moveWhiteNo)}>{moveWhite}</td>
                                    <td onClick = {()=>this.gotoMove(moveBlackNo)}>{moveBlack}</td></tr>);
            
            }
            result.body =
                <TabPane tabId="1" style={{ height:'100%' }}>
                    <Row>
                        <div>&nbsp;</div>
                        <Col sm="12">
                            <div style={{width:'100%', height: this.state.tabContentHeight, 
                                    overflowY: 'scroll' }} ref='scrollBar'>
                                <Table><thead><tr>
                                        <th>#</th>
                                        <th>white</th>
                                        <th>black</th>
                                    </tr></thead>
                                    <tbody>
                                        {movesArrayHtml}
                                    </tbody>
                                </Table>
                            </div>      
                            <div>&nbsp;</div>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="6">
                            <h5>Result <Badge color="danger">{this.props.gameData.result}</Badge></h5>
                        </Col>
                        <Col sm="6">
                            {this.getPDNButton()}
                        </Col>
                    </Row>
                </TabPane>
        }
        
        return result;
    }

    onMessageModalResult(result) {
        this.setState({
            messageModal: {
                visible: false
            }
        })
    }

    toogleMovesEdit() {
        let movesEdit = !this.state.movesEdit;
        const userID = this.game.gameJSON.editUserId != null ? parseInt(this.game.gameJSON.editUserId, 10) : 0;
        if (this.gameOnline) {
            if (movesEdit) {
                this.toggleAutoPlay(0);
            } else {
                this.toggleAutoPlay(2000);
            }
        }
        if (movesEdit) {
            this.lastMove();
        }
        this.setState({
            movesEdit: movesEdit,
            selectedSquares: this.game.getEmptySelectedSquare()
        })
    }

    renderToolsWindow() {
        const sizeComp = parseInt(this.props.size, 10);
        const movesTab = this.getMovesListTab();
        const commentTab = this.getCommentsTab(sizeComp);
        return (
            <Card className="gameCard" style={{ width:sizeComp, height:this.state.baseHeight }}>
                <CardBody>
                    <div>
                        <Nav tabs>
                            {movesTab.header}
                            {commentTab.header}
                        </Nav>
                        <TabContent activeTab={this.state.activeTab}>
                            {movesTab.body}
                            {commentTab.body}
                        </TabContent>
                    </div>
                </CardBody>
            </Card>
        )
    }

    render() {
        const props = this.props;
        const state = this.state;
        const sizeComp = parseInt(props.size, 10);
        let move = state.currentPositionData.move;
        const whiteClock = move !== null ? move.clockWhite : null;
        const blackClock = move !== null ? move.clockBlack : null;
        const onMoveWhite = move !== null ? move.color === COLOR.BLACK : false;
        const onMoveBlack = move !== null ? move.color === COLOR.WHITE : false;
        let topPlayerData = {
            photo:state.blackPlayerPhoto,
            name:state.blackPlayerName,
            title:state.blackPlayerTitle,
            flag:state.blackPlayerFlag,
            time:blackClock,
            onMove: onMoveBlack,
            result: state.blackPlayerResult,
            gameOnline: this.state.gameOnline,
        }
        
        let topCard = <BoardViewPlayer whiteOnTop={this.state.whiteOnTop} playerData={topPlayerData} clock></BoardViewPlayer>

        let bottomPlayerData = {
            photo:state.whitePlayerPhoto,
            name:state.whitePlayerName,
            title:state.whitePlayerTitle,
            flag:state.whitePlayerFlag,
            time:whiteClock,
            onMove: onMoveWhite,
            result: state.whitePlayerResult,
            gameOnline: this.state.gameOnline,
        }

        let bottomCard = <BoardViewPlayer whiteOnTop={this.state.whiteOnTop} playerData={bottomPlayerData}></BoardViewPlayer>
        const chessNotation = this.state.draughtsType === DraughtsTypes8x8.BRAZILIAN || this.state.draughtsType === DraughtsTypes8x8.RUSSIAN;
        if (this.state.whiteOnTop) {
            let tmp = bottomCard;
            bottomCard = topCard;
            topCard = tmp;
        }

        const toolWindow = this.state.toolsWindowEnable ? this.renderToolsWindow() : null;
        const checkedIcon = "glyphicon glyphicon-check";
        const uncheckedIcon = "glyphicon glyphicon-unchecked";

        const autoPlayIcon = this.state.autoPlayInterval !== 0 
                ? <span className="glyphicon glyphicon-pause"></span> 
                : <span className="glyphicon glyphicon-play"></span>;
        const moves = (this.state.movesTekstArray.length > 0 && this.state.movesTekstArray[0].white) ? this.state.movesTekstArray.length : 0;
        return (
            <div>
            <MessageModal 
                isOpen={state.messageModal.visible}
                resultHandler={this.onMessageModalResult} 
                title={state.messageModal.title} 
                message={state.messageModal.message}>
            </MessageModal>
            <table cellPadding='0px' cellSpacing='0px'><tbody>
            <tr><td ref='baseTD'>
            <Card className="gameCard" style={{ width:sizeComp }} >
                {this.gameOnline &&
                <div style={{backgroundColor:"#d9534f", fontSize: "13px", color:"#ffffff", textAlign:"center", fontWeight:"bold"}}>LIVE GAME</div>}
                {!this.gameOnline &&
                <div style={{backgroundColor:"#999", fontSize: "13px", color:"#ffffff", textAlign:"center"}}>Moves: <b>{moves}</b> / Comments: <b>{this.state.commentsLength ? this.state.commentsLength : 0}</b></div>}
                <CardHeader style={{ backgroundColor: '#eee', paddingTop: "0px", marginTop: "0px"}}>
                    {topCard}
                </CardHeader>
                <CardBody>
                        <QuestionModal 
                            isOpen={state.showQuestionModalDeleteFrom}
                            title="Confirm delete moves"
                            question="Do you want to delete game from that move ?"
                            resultHandler={this.questionModalDeleteRestMoves}
                        ></QuestionModal>
                        
                        <BoardView size={sizeComp - (chessNotation && this.state.movesEdit ? 50 : 40)} 
                            whiteOnTop={state.whiteOnTop} 
                            type={state.boardType} 
                            currentPositionData={state.currentPositionData}
                            clickSquareHandler = {this.onSquareClick} 
                            selectedSquares = {state.selectedSquares} 
                            editMode = {this.state.movesEdit}
                            chessNotation = {chessNotation}
                            draughtsType={this.state.draughtsType}
                            >
                        </BoardView>
                        <CardText></CardText>
                        <table cellSpacing="0px" cellPadding="0px">
                            <tbody>
                            <tr>
                                <td style={{width:"10%", textAlign:"left"}}>
                                    <Dropdown size="sm" direction="up" isOpen={this.state.btnDropleft} toggle={() => { this.setState({ btnDropleft: !this.state.btnDropleft }); }}>
                                    <DropdownToggle><span className="glyphicon glyphicon-cog"></span></DropdownToggle>
                                    <DropdownMenu>
                                        {this.props.settingsData.isGameEditUserLogin &&
                                        <div>
                                        <DropdownItem onClick={() => this.toogleMovesEdit()}><span className={state.movesEdit ? checkedIcon : uncheckedIcon}></span>&nbsp;Enable moves edit</DropdownItem>
                                        <DropdownItem onClick={() => this.deleteGameFromThatMove()}><span style={{paddingLeft: "20px"}}>Delete game from that move</span></DropdownItem>
                                        </div>}
                                        <DropdownItem divider />
                                        <DropdownItem onClick={() => this.flipBoard()}><span className={state.whiteOnTop ? checkedIcon : uncheckedIcon}></span>&nbsp;Flip colour</DropdownItem>
                                        <DropdownItem divider />
                                        <DropdownItem onClick={() => this.toggleAutoPlay(1000)}><span className={this.state.autoPlayInterval === 1000 ? checkedIcon : uncheckedIcon}></span>&nbsp;Auto play 1 sec.</DropdownItem>
                                        <DropdownItem onClick={() => this.toggleAutoPlay(2000)}><span className={this.state.autoPlayInterval === 2000 ? checkedIcon : uncheckedIcon}></span>&nbsp;Auto play 2 sec.</DropdownItem>
                                        <DropdownItem onClick={() => this.toggleAutoPlay(4000)}><span className={this.state.autoPlayInterval === 4000 ? checkedIcon : uncheckedIcon}></span>&nbsp;Auto play 4 sec.</DropdownItem>
                                    </DropdownMenu>
                                    </Dropdown>
                                </td>
                                <td style={{width:"90%", textAlign:"right"}}>
                                    {this.state.needsUpdatePDN &&
                                    <Button color="danger" size="sm" onClick={() => this.postDataToServer()}><span className="glyphicon glyphicon-floppy-open"></span></Button>
                                    }
                                    &nbsp;
                                    <Button size="sm" onClick={() => this.firstMove()}><span className="glyphicon glyphicon-fast-backward"></span></Button>&nbsp;
                                    <Button size="sm" onClick={() => this.prevMove()}><span className="glyphicon glyphicon-backward"></span></Button>&nbsp;
                                    <Button size="sm" onClick={() => this.toggleAutoPlay(this.state.autoPlayInterval !== 0 ? 0 : 2000)}>{autoPlayIcon}</Button>&nbsp;
                                    <Button size="sm" onClick={() => this.nextMove()}><span className="glyphicon glyphicon-forward"></span></Button>&nbsp;
                                    <Button size="sm" onClick={() => this.lastMove()}><span className="glyphicon glyphicon-fast-forward"></span></Button>&nbsp;
                                    {this.getMovesListButton(toolWindow)}
                                </td>
                                
                            </tr>
                            </tbody>
                        </table>
                </CardBody>
                <CardFooter style={{ backgroundColor: '#eee'}}>
                    {bottomCard}
                </CardFooter>
                <div style={{backgroundColor:"#999", fontSize: "13px", color:"#ffffff", textAlign:"center"}}>
                    <a style={{fontSize: "13px", color:"#ffffff"}} href="http://fmjd.org" target="_BLANK">fmjd.org</a>
                </div>
            </Card>
            </td><td>
            {toolWindow}
            </td></tr>
            </tbody></table>
            </div>
        )
    }
    
} 


// WEBPACK FOOTER //
// ./src/board/GameComponent.js